export default __webpack_public_path__ + "static/media/Email-icon.093b3167.svg";